import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { BText } from '../../components';
import { logoutUser } from '../../store/user/userActions';

export const Logout = ({ navigation }: any) => {
  const dispatch = useAppDispatch();
  const user = useAppSelector(s => s.user);

  useEffect(() => {
    if (user.isLogout) {
      navigation.navigate('home');
    }
  }, [user.isLogout]);

  useEffect(() => {
    dispatch(logoutUser());
  }, []);

  const style = {
    flex: 1,
    margin: 'auto',
  };
  return <BText style={style}>Logout, please wait...</BText>;
};
